export const NOTIFICATION_EVENTS = Object.freeze({
  POLL_CREATED: "POLL_CREATED",
  POLL_INVITE_SENT: "POLL_INVITE_SENT",
  POLL_INVITE_ACCEPTED: "POLL_INVITE_ACCEPTED",
  POLL_INVITE_DECLINED: "POLL_INVITE_DECLINED",
  POLL_INVITE_REVOKED: "POLL_INVITE_REVOKED",
  VOTE_SUBMITTED: "VOTE_SUBMITTED",
  VOTE_REMINDER: "VOTE_REMINDER",
  POLL_READY_TO_FINALIZE: "POLL_READY_TO_FINALIZE",
  POLL_ALL_VOTES_IN: "POLL_ALL_VOTES_IN",
  POLL_FINALIZED: "POLL_FINALIZED",
  POLL_REOPENED: "POLL_REOPENED",
  POLL_CANCELLED: "POLL_CANCELLED",
  POLL_RESTORED: "POLL_RESTORED",
  POLL_DELETED: "POLL_DELETED",
  SESSION_RESCHEDULED: "SESSION_RESCHEDULED",
  SESSION_RESTORED: "SESSION_RESTORED",
  SESSION_CANCELLED: "SESSION_CANCELLED",
  SESSION_UPCOMING_REMINDER: "SESSION_UPCOMING_REMINDER",
  BASIC_POLL_CREATED: "BASIC_POLL_CREATED",
  BASIC_POLL_FINALIZED: "BASIC_POLL_FINALIZED",
  BASIC_POLL_REOPENED: "BASIC_POLL_REOPENED",
  BASIC_POLL_VOTE_SUBMITTED: "BASIC_POLL_VOTE_SUBMITTED",
  BASIC_POLL_REMINDER: "BASIC_POLL_REMINDER",
  BASIC_POLL_RESET: "BASIC_POLL_RESET",
  BASIC_POLL_REMOVED: "BASIC_POLL_REMOVED",
  BASIC_POLL_DEADLINE_CHANGED: "BASIC_POLL_DEADLINE_CHANGED",
  BASIC_POLL_REQUIRED_CHANGED: "BASIC_POLL_REQUIRED_CHANGED",
  BASIC_POLL_RESULTS: "BASIC_POLL_RESULTS",
  BASIC_POLL_FINALIZED_WITH_MISSING_REQUIRED_VOTES:
    "BASIC_POLL_FINALIZED_WITH_MISSING_REQUIRED_VOTES",
  SLOT_CHANGED: "SLOT_CHANGED",
  DISCORD_NUDGE_SENT: "DISCORD_NUDGE_SENT",
  FRIEND_REQUEST_SENT: "FRIEND_REQUEST_SENT",
  FRIEND_REQUEST_ACCEPTED: "FRIEND_REQUEST_ACCEPTED",
  FRIEND_REQUEST_DECLINED: "FRIEND_REQUEST_DECLINED",
  FRIEND_REMOVED: "FRIEND_REMOVED",
  GROUP_INVITE_SENT: "GROUP_INVITE_SENT",
  GROUP_INVITE_ACCEPTED: "GROUP_INVITE_ACCEPTED",
  GROUP_INVITE_DECLINED: "GROUP_INVITE_DECLINED",
  GROUP_MEMBER_REMOVED: "GROUP_MEMBER_REMOVED",
  GROUP_MEMBER_LEFT: "GROUP_MEMBER_LEFT",
  GROUP_DELETED: "GROUP_DELETED",
  CALENDAR_AUTH_EXPIRED: "CALENDAR_AUTH_EXPIRED",
  AUTO_VOTE_OVERRIDE: "AUTO_VOTE_OVERRIDE",
  VOTE_AUTO_APPLIED: "VOTE_AUTO_APPLIED",
  VOTE_CASCADE_APPLIED: "VOTE_CASCADE_APPLIED",
  SESSION_EXTERNAL_CONFLICT: "SESSION_EXTERNAL_CONFLICT",
  AVAILABILITY_WINDOW_INVALIDATED: "AVAILABILITY_WINDOW_INVALIDATED",
  SESSION_RESCHEDULE_CONFLICT: "SESSION_RESCHEDULE_CONFLICT",
  SESSION_DOUBLE_BOOKED: "SESSION_DOUBLE_BOOKED",
  RSVP_AUTO_CHANGED: "RSVP_AUTO_CHANGED",
  SUBSCRIPTION_UPDATED: "SUBSCRIPTION_UPDATED",
  SUBSCRIPTION_LAPSED: "SUBSCRIPTION_LAPSED",
});

const LEGACY_NOTIFICATION_TYPES = Object.freeze({
  FRIEND_REQUEST: "FRIEND_REQUEST",
  FRIEND_ACCEPTED: "FRIEND_ACCEPTED",
  POLL_INVITE: "POLL_INVITE",
  GROUP_INVITE: "GROUP_INVITE",
  GROUP_INVITE_ACCEPTED: "GROUP_INVITE_ACCEPTED",
  SESSION_INVITE: "SESSION_INVITE",
  SESSION_FINALIZED: "SESSION_FINALIZED",
  SESSION_JOINED: "SESSION_JOINED",
  GROUP_MEMBER_CHANGE: "GROUP_MEMBER_CHANGE",
});

export const NOTIFICATION_TYPES = Object.freeze({
  ...NOTIFICATION_EVENTS,
  ...LEGACY_NOTIFICATION_TYPES,
});

export const NOTIFICATION_TYPE_ALIASES = {
  [NOTIFICATION_TYPES.FRIEND_REQUEST_SENT]: NOTIFICATION_TYPES.FRIEND_REQUEST,
  [NOTIFICATION_TYPES.FRIEND_REQUEST_ACCEPTED]: NOTIFICATION_TYPES.FRIEND_ACCEPTED,
  [NOTIFICATION_TYPES.POLL_INVITE_SENT]: NOTIFICATION_TYPES.POLL_INVITE,
  [NOTIFICATION_TYPES.POLL_INVITE_ACCEPTED]: NOTIFICATION_TYPES.SESSION_JOINED,
  [NOTIFICATION_TYPES.POLL_FINALIZED]: NOTIFICATION_TYPES.SESSION_FINALIZED,
  [NOTIFICATION_TYPES.GROUP_INVITE_SENT]: NOTIFICATION_TYPES.GROUP_INVITE,
  [NOTIFICATION_TYPES.GROUP_INVITE_ACCEPTED]: NOTIFICATION_TYPES.GROUP_INVITE_ACCEPTED,
  [NOTIFICATION_TYPES.GROUP_MEMBER_REMOVED]: NOTIFICATION_TYPES.GROUP_MEMBER_CHANGE,
  [NOTIFICATION_TYPES.GROUP_MEMBER_LEFT]: NOTIFICATION_TYPES.GROUP_MEMBER_CHANGE,
};

export function normalizeNotificationType(type) {
  return NOTIFICATION_TYPE_ALIASES[type] || type;
}
